var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M28.3,65.5,0,7.84V0L33,65.5,0,131v-7.88Z"}));
}

ArrowRight.defaultProps = {"viewBox":"0 0 33 131"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
